import * as React from 'react';
import { Modal, ModalFooter } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import { CheckoutForm } from '../../components/Forms/CheckoutForm.js';
import { FormFieldsWithCart } from '../../components/FormFieldsWithCart/FormFieldsWithCart.js';
import { useIsFormSlotAvailable } from '../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../state.js';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import { getContactDetailsFormData, getShippingData } from '../../StepShipping/selectors.js';

const EditableContactDetailsSummary = ({ labels  })=>{
    var ref, ref1;
    const isContactFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.ContactDetails);
    const [ContactDetailsFormData, setContactDetailsFormData] = React.useState();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const contactDetailsInitialData = useSelector(getContactDetailsFormData);
    const dispatch = useDispatch();
    const contactDetailsData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.contactDetails;
    const hasData = React.useMemo(()=>contactDetailsData && !Object.values(contactDetailsData).every((x)=>x === null || x === ''
        )
    , [
        contactDetailsData
    ]);
    const ContactDetailsSummarySlot = Slots.contactDetails;
    if (!ContactDetailsSummarySlot && hasData) {
        console.error('This opco is misconfigured. It has contact details data, but no contact details summary card setup.');
    }
    if (!ContactDetailsSummarySlot || !hasData) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isContactFormAvailable && /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref1 = labels.editModal) === null || ref1 === void 0 ? void 0 : ref1.save,
            onCta: ()=>{
                if (!(ContactDetailsFormData === null || ContactDetailsFormData === void 0 ? void 0 : ContactDetailsFormData.formValid)) {
                    Util.focusToTopErrorFieldOnScreen();
                } else {
                    ContactDetailsFormData && dispatch(updateShippingDetails({
                        form: ContactDetailsFormData
                    }));
                    setIsModalOpen(false);
                }
            },
            onCancel: ()=>setIsModalOpen(false)
        })
    }, /*#__PURE__*/ React.createElement(CheckoutForm, {
        formName: "contactDetails",
        "data-t": "contactDetails",
        initialFormState: contactDetailsInitialData,
        onChange: (formData)=>setContactDetailsFormData(formData)
    }, /*#__PURE__*/ React.createElement(FormFieldsWithCart, {
        formName: ShippingObjectTypes.ContactDetails
    }))), hasData && /*#__PURE__*/ React.createElement(ContactDetailsSummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: contactDetailsData
    }));
};

export { EditableContactDetailsSummary, EditableContactDetailsSummary as default };
//# sourceMappingURL=EditableContactDetailsSummary.js.map
